import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { DEFAULT_BUTTON_WIDTH, HEADER_BUTTON_HEIGHT } from '../../utils/styled/dimensions';

export const Components = {
  Container: styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 16px 24px;
    background-color: ${AppCSS.colors.utility.screenBackground};
    gap: 32px;
    min-width: fit-content;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  SearchBarSeparator: styled.div`
    width: 1px;
    height: 38px;
    background-color: ${AppCSS.colors.greys.light};
  `,
  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)`
    width: ${DEFAULT_BUTTON_WIDTH}px;
    min-width: ${DEFAULT_BUTTON_WIDTH}px;
    height: ${HEADER_BUTTON_HEIGHT}px;
    min-height: ${HEADER_BUTTON_HEIGHT}px;
  `,
};
